import { render, staticRenderFns } from "./ProspectImportDetails.vue?vue&type=template&id=22eddb91&scoped=true&"
import script from "./ProspectImportDetails.vue?vue&type=script&lang=js&"
export * from "./ProspectImportDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProspectImportDetails.vue?vue&type=style&index=0&id=22eddb91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eddb91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VSimpleCheckbox,VTextField})
